var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { wrapDispatch } from "../../Multireducer";
import { Icon } from "../../UI";
import { DropdownList } from "../../Forms";


import { omit } from 'lodash';
import {
filterTemplates,
getPropertySortType,
getSortOptions } from "../helpers/sortComponets";










const mapStateToProps = (state, ownProps) => {
  let { templates } = state;
  const stateProperty = ownProps.stateProperty ? ownProps.stateProperty : 'library.search';

  if (ownProps.selectedTemplates && ownProps.selectedTemplates.count()) {
    templates = filterTemplates(state.templates, ownProps.selectedTemplates);
  }
  const search = stateProperty.
  split(/[.,/]/).
  reduce(
  (memo, property) =>
  Object.keys(memo).indexOf(property) !== -1 ? memo[property] : null,
  state);

  return _objectSpread(_objectSpread({}, ownProps), {}, { stateProperty, search, templates });
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ merge: actions.merge }, wrapDispatch(dispatch, 'library'));

const connector = connect(mapStateToProps, mapDispatchToProps);



const getToggleSearchIcon = (search) =>
search.order === 'asc' && search.sort !== '_score' ? 'arrow-up' : 'arrow-down';

const validateSearch = (search) =>
search.sort === '_score' && !search.searchTerm ?
{
  sort: 'creationDate',
  order: 'desc',
  searchTerm: search.searchTerm
} :
{ searchTerm: search.searchTerm, sort: search.sort };

const sortDirection = (condition) => {
  switch (condition) {
    case 'desc':
    case 'string':
      return 'asc';
    case 'asc':
    default:
      return 'desc';}

};

const SortButtonsComponent = ({
  search,
  merge,
  stateProperty,
  templates,
  sortCallback
}) => {
  const doSort = (property, defaultTreatAs, selectedSort) => {
    const treatAs = defaultTreatAs;
    const order = selectedSort || sortDirection(treatAs);
    const newSort = { sort: property, order, treatAs };
    merge(stateProperty, newSort);
    const filters = _objectSpread(_objectSpread(_objectSpread({}, search), omit(newSort, 'treatAs')), {}, { userSelectedSorting: true });
    return sortCallback && sortCallback({ search: filters }, 'library');
  };

  const changeOrder = () => {
    doSort(search.sort, search.treatAs, sortDirection(search.order));
  };

  const validatedSearch = validateSearch(search);

  const sortOptions = getSortOptions(search, templates);

  return /*#__PURE__*/(
    _jsx("div", { className: "sort-buttons" }, void 0, /*#__PURE__*/
    _jsx(DropdownList, {
      className: "sort-dropdown",
      value: validatedSearch.sort,
      data: sortOptions,
      valueField: "value",
      textField: "label",
      onChange: (selected) => doSort(selected.value, getPropertySortType(selected)) }), /*#__PURE__*/

    _jsx("button", {
      type: "button",
      disabled: search.sort === '_score',
      className: `sorting-toggle ${search.sort === '_score' && 'disabled'}`,
      onClick: changeOrder }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: getToggleSearchIcon(search) }))));



};

const container = connector(SortButtonsComponent);

export { container as SortButtons, mapStateToProps };